// src/features/dashboard/components/charts/TotalUsersChart/TotalUsersChart.jsx
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import SupervisorAccountRoundedIcon from "@mui/icons-material/SupervisorAccountRounded";

import ChartWrapper from "../../../../../components/common/ChartWrapper/ChartWrapper";
import ChartHeader from "../../../../../components/common/ChartHeader/ChartHeader";
import { transformBuCountData } from "../../../utils/chartTransformers";
import BarChart from "../../../../../components/Charts/BarChart/BarChart";

import "../dashboardCharts.scss";

const TotalUsersChart = () => {
  const { buCount, buCountFetching } = useSelector((s) => s.dashboard);
  const countData = transformBuCountData(buCount);
  const isEmpty = countData.labels.length === 0;

  return (
    <Box className="chart-card animate-card">
      <ChartHeader
        icon={SupervisorAccountRoundedIcon}
        title="Total Number of Users"
      />
      <ChartWrapper
        isLoading={buCountFetching}
        isEmpty={isEmpty}
        height="315px"
      >
        <BarChart data={countData} yAxisTitle="Number of Users" />
      </ChartWrapper>
    </Box>
  );
};

export default TotalUsersChart;
